<!-- v1.5 - in use -->

<template>
	<section id="recommendedProducts">
		<loadingAnimation v-if="loading"></loadingAnimation>

		<axiosError v-else-if="error"></axiosError>

<!--   	<div v-else class="coto_slide-toggle coto_open">
			<div class="coto_toggle-button">
				<h2>Recommended Products</h2> 
			</div>
            <div class="coto_slide-dropdown coto_default-open">
				<div class="coto_row coto_col-sm-stack">
                    <div v-for="product in recommendedProducts.slice(0, 4)" class="coto_column coto_col-md-3">
                        <figure v-on:click="followLink(product)" class="product-related">
                            <img :src="product.media[0].src" :alt="product.media[0].alt" :data-type="product.media[0].media_type" itemprop="image" width="300" height="300" />
                            
                            <div class="grid-view-item__title product-title">{{ product.title }}</div>

                            
                            <div class="grid-view-item__title product-price">{{ money(product.price) }}</div>
                        </figure>
                    </div>
                </div>
            </div>
        </div> -->
		
		<div v-else class="row">
			<div class="col-12">
				<h2>Recommended Products</h2> 
			</div><!-- .col -->
			<div class="col-12">
				<div class="row mobile-scroll">
					<div v-for="product in recommendedProducts.slice(0, 3)" class="col-12 col-md-4">
						<div class="ctpx-product-item" v-on:click="followLink(product)">
							<div class="product-image">
								<img :src="product.media[0].src" :alt="product.media[0].alt" :data-type="product.media[0].media_type" draggable="false" id="prod215866736650" width="400" height="400" class="img-responsive">
								<span v-if="tagExists('new', product.tags)" class="btn btn-default">New</span>
								<span v-else-if="tagExists('sale', product.tags)" class="btn btn-default sale">Sale</span>
								<span v-else-if="tagExists('final sale', product.tags)" class="btn btn-default fsale">Final Sale</span>
							</div><!-- .product-image -->
							<div class="product-details">
								<div class="row">
									<div class="col-8">
										<h6 class="product-title">{{ product.title }}</h6>
									</div><!-- .col-8 -->
									<div class="col-4 text-right">
										<h6 v-if="product.compare_at_price > product.price && product.compare_at_price !== 0 && product.compare_at_price !== null" class="product-price">
										 <s>{{ money(product.compare_at_price) }}</s> - {{ money(product.price) }}
										</h6>
										<h6 v-else class="product-price">
											{{ money(product.price) }}
										</h6>
									</div> <!-- .col-4 -->
								</div><!-- .row --> 
							</div><!-- .product-details --> 
						</div><!-- .ctpx-product-item -->
					</div>
				</div><!-- row -->
			</div>
		</div>

    </section>
</template>

<script src="./ctrl-recommended-products.js"></script>